"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidClasses = void 0;
const clsx_1 = __importDefault(require("clsx"));
const getValidClasses = (...args) => (0, clsx_1.default)(...args);
exports.getValidClasses = getValidClasses;
